export const buildProgress = (percentual: number): string => {
  const w = (percentual * 598) / 100;
  return `<svg width="598" height="12" viewBox="0 0 598 12" fill="red" xmlns="http://www.w3.org/2000/svg">
        <rect width="598" height="12" rx="2" fill="#BDBDBD"/>
        <mask id="mask1_9533_2537" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="${w}" height="12"><rect width="598" height="12" rx="2" fill="#E0E0E0"/></mask>
        <g mask="url(#mask1_9533_2537)"><rect width="609.687" height="12" rx="2" fill="url(#paint0_linear_9533_2537)"/></g>
        <defs>
          <linearGradient id="paint0_linear_9533_2537" x1="0" y1="11.9999" x2="609.687" y2="11.9999" gradientUnits="userSpaceOnUse">
            <stop stop-color="#FF5454"/>
            <stop offset="0.479167" stop-color="#FFB054"/>
            <stop offset="1" stop-color="#63DC76"/>
          </linearGradient>
        </defs>
      </svg>`;
};
